export const headCells = [
    {id: "id", label: ""},
    {id: "date", label: "Data"},
    {id: "duration", label: "Czas (min)"},
    {id: "reason", label: "Opis wniosku"},
    {id: "comment", label: "Komentarz Administratora"},
    {id: "adminApproval", label: "Status"},
];
